import * as React from 'react';

export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <g clipPath="url(#clip0_11414_47464)">
      <path
        fill="#4024D3"
        d="M4 4.667c0 .366.3.666.667.666h5.06l-5.92 5.92a.664.664 0 1 0 .94.94l5.92-5.92v5.06c0 .367.3.667.666.667s.667-.3.667-.667V4.667C12 4.3 11.7 4 11.333 4H4.667C4.3 4 4 4.3 4 4.667"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_11414_47464">
        <path fill="#fff" d="M0 0h16v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
